import { Directive } from '@angular/core';

@Directive({
    selector: '[luiAlertIcon]',
    standalone: false
})
export class AlertIconDirective {}

@Directive({
    selector: '[luiAlertFooter]',
    standalone: false
})
export class AlertFooterDirective {}
